<template>
  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">{{heading}}</h1>
    <div class="btn-toolbar mb-2 mb-md-0">
      <div 
        v-if="buttons && buttons.length > 0"
        class="btn-group mr-2">
        <button 
          v-for="(button, index) in buttons"
          :key=index
          type="button" 
          class="btn btn-sm btn-outline-secondary"
          @click="handleButtonClick(button)">
          {{button.label}}  
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageHeader',
  props: {
   heading: String,
   buttons: Array
  },
  computed: {
    
  },
  methods: {
    handleButtonClick (button) {
      this.$emit('button-click', button)
    }
  }
}

</script>

<style scoped>
</style>
